import { useTranslation } from '../../../../../utils/useTranslation';
import { IconChecked } from '../../../../icon/IconChecked';
import { IconChevron } from '../../../../icon/IconChevron';
import { FormControl } from '../../../../input/FormControl';
import { Box } from '../../../../layout/Box';
import { Menu, MenuItem } from '../../../../navigation/Menu';
import { Typography } from '../../../../typography/Typography';
import { Control, ControlWrapper, Wrapper } from './styles';
import { ContentPromotionDropdownProps } from './types';

export const ContentPromotionDropdown: React.FC<ContentPromotionDropdownProps> = ({
    label,
    value,
    options,
    onChange,
    disabled,
    trigger,
    ...other
}) => {
    const t = useTranslation();

    const currentOption = options?.find((option) => option.value === value);

    return (
        <Wrapper {...other} disabled={disabled}>
            <FormControl label={label ? t(label) : ''} width="100%">
                <>
                    <Menu
                        options={{ placement: 'bottom-start' }}
                        width="100%"
                        trigger={
                            trigger ? (
                                trigger
                            ) : (
                                <ControlWrapper>
                                    <Control>{currentOption?.label}</Control>
                                    <Box position="absolute" right={2} top={2}>
                                        <IconChevron size={16} color="var(--color-primary)" />
                                    </Box>
                                </ControlWrapper>
                            )
                        }
                    >
                        {options?.map(({ value, label }) => (
                            <MenuItem
                                key={value}
                                spacing={1}
                                direction="row"
                                justifyContent="space-between"
                                onClick={() => onChange(value)}
                            >
                                <Typography variant="body" noWrap>
                                    {label}
                                </Typography>
                                <IconChecked
                                    size={20}
                                    color={
                                        value === currentOption?.value
                                            ? 'var(--color-primary)'
                                            : 'transparent'
                                    }
                                />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            </FormControl>
        </Wrapper>
    );
};
